<template>
  <svg
    width="15"
    height="12"
    viewBox="0 0 15 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.5 0C0.129 0 0 0.681039 0 6C0 11.319 0.129 12 7.5 12C14.871 12 15 11.319 15 6C15 0.681039 14.871 0 7.5 0ZM9.90375 6.26026L6.53625 7.89351C6.2415 8.03532 6 7.87636 6 7.53818V4.46182C6 4.12442 6.2415 3.96468 6.53625 4.10649L9.90375 5.73974C10.1985 5.88312 10.1985 6.11688 9.90375 6.26026Z"
    />
  </svg>
</template>
